import DashBoardPlug from './DashBoardPlug';

export default DashBoardPlug;
